import React from "react";
import MetricTableRowPdf from "MetricTableRowPdf";
import Table from "react-bootstrap/Table";
import _ from "lodash";
import jsDig from "utils/jsDig";

class MetricTablePdf extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      table: props.table,
      date: moment(props.date),
      headerOrder: this.props.headerOrder,
      width: window.innerWidth,
    };
  }

  render() {
    if (!this.props.table) return <div>No Data To Display Yet!</div>;
    let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const headerClass = this.props.ppc ? "ppc-table-row-header" : " seo-table-row-header";
    const renderHeader = this.state.headerOrder.map((metricName, index) => {
      let metricTitle = _.startCase(_.camelCase(metricName));
      return (
        <th scope="col" className={`table-row-header-pdf table-row-header ${headerClass}`} colSpan="3" key={index}>
          {metricTitle}
        </th>
      );
    });

    return (
      <React.Fragment>
        <div className={this.props.responsive ? "table-responsive" : ""}>
          <Table className={`mt-2 table-white table-striped metric-table-compact metric-table`}>
            <thead>
              <tr>
                <th scope="col" colSpan="1" className="yy-table-header" style={{ border: "none" }}></th>
                {renderHeader}
              </tr>
              <tr className="dates bg-transparent">
                <th className="bg-transparent empty-space" style={{ border: "none" }}></th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <React.Fragment key={metricName}>
                      <th scope="col" className="bg-white " style={{ border: "1px solid #e1e1e1 " }}>
                        {parseInt(this.props.date.substring(0, 4)) - 1}
                      </th>
                      <th scope="col" className="bg-white " style={{ border: "1px solid #e1e1e1 " }}>
                        {" "}
                        {this.state.date.year()}{" "}
                      </th>
                      <th scope="col" className="bg-white " style={{ border: "1px solid #e1e1e1 " }}>
                        Y/Y
                      </th>
                    </React.Fragment>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => {
                return (
                  <tr key={num}>
                    <th className={(num % 3 != 0 ? "no-border-tb" : "no-border-t") + " text-left "} scope="row">
                      <span className="metric-table-month">{months[num - 1]} </span>
                    </th>
                    {this.state.headerOrder.map((metricName) => {
                      return (
                        <MetricTableRowPdf
                          key={metricName}
                          client={this.props.client}
                          metricName={metricName}
                          rowNumber={num}
                          thisYearValue={jsDig([metricName, this.state.date.year().toString(), num.toString()], this.state.table)}
                          lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), num.toString()], this.state.table)}
                          indexOf={this.state.headerOrder.indexOf(metricName)}
                          baseCurrency={this.props.baseCurrency}
                          displayCurrency={this.props.displayCurrency}
                        />
                      );
                    })}
                  </tr>
                );
              })}
              <tr style={{ backgroundColor: "#e0e4ef" }}>
                <th className="no-border-tb text-left" scope="row">
                  <span className="metric-table-month">YTD</span>
                </th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <MetricTableRowPdf
                      key={metricName}
                      client={this.props.client}
                      metricName={metricName}
                      rowNumber={13}
                      thisYearValue={jsDig([metricName, this.state.date.year().toString(), "ytd"], this.state.table)}
                      lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), "ytd"], this.state.table)}
                      indexOf={this.state.headerOrder.indexOf(metricName)}
                      baseCurrency={this.props.baseCurrency}
                      displayCurrency={this.props.displayCurrency}
                    />
                  );
                })}
              </tr>
              <tr style={{ backgroundColor: "#e0e4ef" }}>
                <th className="no-border-t text-left" scope="row">
                  <span className="metric-table-month">Total</span>
                </th>
                {this.state.headerOrder.map((metricName) => {
                  return (
                    <MetricTableRowPdf
                      key={metricName}
                      client={this.props.client}
                      metricName={metricName}
                      rowNumber={14}
                      thisYearValue={jsDig([metricName, this.state.date.year().toString(), "total"], this.state.table)}
                      lastYearValue={jsDig([metricName, (this.state.date.year() - 1).toString(), "total"], this.state.table)}
                      bottomRow={true}
                      indexOf={this.state.headerOrder.indexOf(metricName)}
                      baseCurrency={this.props.baseCurrency}
                      displayCurrency={this.props.displayCurrency}
                    />
                  );
                })}
              </tr>
            </tbody>
          </Table>
        </div>
      </React.Fragment>
    );
  }
}
export default MetricTablePdf;
